module.exports = __webpack_public_path__ + "static/media/LV-GKC.f059e3c3.jpg";